import { useEffect, useState } from 'react';

import { RakindaClient } from './api/rakinda-client';
import { Rakinda } from './rakinda';

declare global {
    interface WindowEventMap {
        'useRakinda:request': CustomEvent<string>;
    }
}

const REQUEST_RAKINDA_EVENT = 'useRakinda:request';
const STORAGE_KEY = 'RKD_REQ';

export function rakindaRequest(rakindaId: string) {
    window.dispatchEvent(new CustomEvent(REQUEST_RAKINDA_EVENT, { detail: rakindaId }));
}

interface Props {
    seedStore: (rakindas: Rakinda[]) => void;
}

export function useRakindas(props: Props) {
    const [pending, changePending] = useState<string[]>([]);
    const [timeoutSet, changeTimeoutSet] = useState<boolean>(false);
    const [timeoutFinished, changeTimeoutFinished] = useState<boolean>(false);

    useEffect(() => {
        window.addEventListener(REQUEST_RAKINDA_EVENT, listener);
    }, []);

    useEffect(() => {
        if (timeoutFinished) {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored != null) {
                changePending(JSON.parse(stored));
                changeTimeoutSet(false);
                changeTimeoutFinished(false);
                localStorage.removeItem(STORAGE_KEY);
            }
        }
    }, [timeoutFinished]);

    useEffect(() => {
        if (pending.length > 0) {
            getRakindas(pending).then((result) => {
                props.seedStore(result);
                changePending([]);
            });
        }
    }, [pending]);

    const listener = (event: CustomEvent) => {
        if (typeof event.detail == 'string') {
            if (timeoutSet === false) {
                changeTimeoutSet(true);
                setTimeout(() => {
                    changeTimeoutFinished(true);
                }, 1000);
            }

            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored == null) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify([event.detail]));
            } else if (!JSON.parse(stored).includes(event.detail)) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify([...JSON.parse(stored), event.detail]));
            }
        }
    };

    async function getRakindas(rakindaIds: string[]): Promise<Rakinda[]> {
        const response = await RakindaClient.resolveRakindas(rakindaIds);
        return response.results;
    }
}
